import axios from 'axios';
import GET_EDUCATIONS from './const';

export default () => {
  const request = axios.get('https://webtools.au.dk/api/Evu/GetList');

  return {
    type: GET_EDUCATIONS,
    payload: request,
  };
};
